module.exports = __webpack_public_path__ + "img/b.a9405d37.png";